export const commonReduxActionTypes = {
  GET_CONFIG: 'GET_CONFIG',
  IS_LOGIN_MODAL_SHOW: 'IS_LOGIN_MODAL_SHOW',
  IS_LOADER_SHOW: 'IS_LOADER_SHOW',
  GET_FAQ: 'GET_FAQ',
  IS_HTT_SHOW: 'IS_HTT_SHOW',
  SET_APP_PAUSED: 'app/Paused',
  SET_APP_RESUMED: 'app/Resumed',
  SET_IS_LOGIN: 'SET_IS_LOGIN',
  SET_INITIAL_DYNAMIC_LINK: 'SET_INITIAL_DYNAMIC_LINK',
};
